import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#00274D",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#4D6882",
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
    custom: {
      surface: "#F5F5F5",
    },
    action: {
      disabledBackground: "#E0E0E0",
      disabled: "#9E9E9E",
    },
    success: {
      main: "#99A8B7",
      contrastText: "#FFFFFF",
    },
  },
});

export default theme;
